function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import MUICheckbox from '@material-ui/core/Checkbox';
import { CheckboxUncheckedIcon } from './checkbox-unchecked-icon.component';
import { CheckboxCheckedIcon } from './checkbox-checked-icon.component';
import { IndeterminateIcon } from './checkbox-indeterminate-icon.component';
export var Checkbox = function Checkbox(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      e2e = props['data-e2e'],
      disableRippleProp = props.disableRipple,
      inputPropsProp = props.inputProps,
      other = _objectWithoutProperties(props, ["color", "data-e2e", "disableRipple", "inputProps"]);

  var inputProps = _objectSpread(_objectSpread({}, inputPropsProp), {}, {
    'data-e2e': e2e
  });

  var isPrimary = color === 'primary';
  var disableRipple = disableRippleProp === undefined ? !isPrimary : disableRippleProp;
  return (
    /*#__PURE__*/
    React.createElement(MUICheckbox, _extends({
      checkedIcon: isPrimary ? undefined :
      /*#__PURE__*/
      React.createElement(CheckboxCheckedIcon, null),
      color: color,
      disableRipple: disableRipple,
      icon: isPrimary ? undefined :
      /*#__PURE__*/
      React.createElement(CheckboxUncheckedIcon, null),
      indeterminateIcon: isPrimary ? undefined :
      /*#__PURE__*/
      React.createElement(IndeterminateIcon, null),
      inputProps: inputProps
    }, other))
  );
};